import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { useFeatureIsOn } from 'src/common/growthbook';
import { runRegionLatencyTest } from 'src/common/latency-test';
import { BootProgressProvider } from '../boot-progress';
import { SplitScreenContent } from '../split-screen-content';
import { SplitScreenNavigation } from '../split-screen-navigation';
import { StyledContent, StyledContentViewer } from './remote-content-viewer.styles';
export const RemoteContentViewer = ({
  isFullscreen = false
}: {
  isFullscreen?: boolean;
}) => {
  const {
    vmPanelOpen,
    tabs,
    currentTab
  } = useAppSelector(state => state.splitScreen);
  const isRegionLatencyTestEnabled = useFeatureIsOn('region-latency-test');
  useEffect(() => {
    if (isRegionLatencyTestEnabled) runRegionLatencyTest().catch(error => {
      Sentry.logger.error('Region latency test failed', {
        error
      });
    });
  }, [isRegionLatencyTestEnabled]);
  return <BootProgressProvider bootTimeRemainingSeconds={currentTab?.vm?.remote?.bootTimeRemainingSeconds} bootTime={currentTab?.vm?.remote?.bootTime} isVmReady={currentTab?.isVmReady} data-sentry-element="BootProgressProvider" data-sentry-component="RemoteContentViewer" data-sentry-source-file="remote-content-viewer.tsx">
      <StyledContentViewer open={vmPanelOpen} data-testid="splitScreenRight" data-sentry-element="StyledContentViewer" data-sentry-source-file="remote-content-viewer.tsx">
        <StyledContent open={vmPanelOpen} data-sentry-element="StyledContent" data-sentry-source-file="remote-content-viewer.tsx">
          {currentTab && <SplitScreenContent currentTabData={currentTab} />}
        </StyledContent>
        <SplitScreenNavigation currentTab={currentTab} tabs={tabs} open={vmPanelOpen} isFullscreen={isFullscreen} data-sentry-element="SplitScreenNavigation" data-sentry-source-file="remote-content-viewer.tsx" />
      </StyledContentViewer>
    </BootProgressProvider>;
};